import { AppRoleSchema } from "./roles";
import type { AppRole } from "./roles";

const ROLE_ROUTES: Record<AppRole, string> = {
  admin: "/admin/dashboard",
  diligencias_manager: "/diligencias-manager/diligencias",
  partner: "/partner/dashboard",
  mfb: "/mfb/dashboard",
  mfa: "/mfa/dashboard",
  assessor: "/assessor/dashboard",
  incorporador: "/incorporador/dashboard",
  investidor: "/investor/dashboard",
};

export const getRoleRedirect = (role: AppRole): string => {
  const parsed = AppRoleSchema.safeParse(role);
  if (!parsed.success) return ROLE_ROUTES.investidor;
  return ROLE_ROUTES[parsed.data];
};
